module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11Ahca1/tc-custom/9781452159355.jpg?1740428357309",
      "alt": "This image is the cover for the book Energy Balls"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Energy Balls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Vegan, no-bake, gluten-free, bite-sized eats for breakfast, lunch, and anytime you need a brain or body boost—or even a relaxing bedtime snack.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This little cookbook packs a big punch with 100 delicious recipes for no-bake energy balls designed to deliver a targeted blast of energy for different activities at any hour. Crafted with whole ingredients, superfoods, and all-natural proteins, each vegan and gluten-free bite-size treat offers the perfect nutritional boost. Extra protein, nuts, and seeds give athletes a high-energy hit; dark chocolate and green tea help students concentrate and focus; ginger lets the overstressed wind down at the end of a long day. And, kids will love them tucked into their lunch boxes. They are as easy to make as they are good to eat—good-bye processed and packaged sports bars! \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christal Sczebel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0